// Ruta del cambio obligatorio de contraseña temporal (primer ingreso o restablecimiento).
export const CAMBIO_CLAVE_PATH = '/cambiar-clave-inicial'
